import { render } from "./gstreport.vue?vue&type=template&id=ef452706&scoped=true"
import script from "./gstreport.vue?vue&type=script&lang=js"
export * from "./gstreport.vue?vue&type=script&lang=js"

import "./gstreport.vue?vue&type=style&index=0&id=ef452706&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef452706"]])

export default __exports__